import { imgsApi } from '../../Api';

export const handleUploadFiles = async (uploadFiles: File[]) => {
    let imgUrls: string[] = [];

    if (uploadFiles.length > 0) {
        try {
            const res: any = await imgsApi.upload(uploadFiles);
            for (let index = 0; index < res.data.urls.length; index++) {
                const element = res.data.urls[index];
                imgUrls.push(element);
            }
        } catch (error) {
            console.error('Failed to upload files:', error);
            return [];
        }
    }

    return imgUrls;
};

export const numberToVND = (number: number) => {
    return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(number);
};

export const parseCurrency = (string: string) => {
    if (!string) return 0;
    // Remove all characters that are not digits.
    return Number(string.replace(/\D/g, ''));
};
